import React from "react";
import ImageCarousel from "../components/ImageCarousel";
import AboutSection from "../components/AboutSection";
import SevenShipContainer from "../components/SevenShipContainer";
import HeroImageSlider from "../components/HeroImageSlider";

import NewsSection from "../components/NewsSection";
import FloatingSocialIcons from "../components/FloatingSocialIcons";
import ScrollToTopButton from "../components/ScrollToTopButton";

const HomePage: React.FC = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="font-sans  text-[#1a1a1a]">
    <FloatingSocialIcons/>
    <ScrollToTopButton/>
      
      {/* Hero Image */}
        <div className="relative">
        {/* Üst kağıt efekti */}
        <img
            src="/images/transbg-top.png"
            alt="Top Torn Paper"
            className="w-full absolute top-0 left-0 z-10 pointer-events-none object-cover"
        />

        <HeroImageSlider/>

        </div>


    <AboutSection/>

      <img
        src="/images/cut2.png"
        alt="Bottom Torn Paper"
        className="block w-full h-auto object-cover border-none outline-none"
      />

    <ImageCarousel/>
    <div className="relative">
      <img
    src="/images/cut3.png"
    alt="Bottom Torn Paper"
    className="block w-full h-auto object-cover border-none outline-none"
        />
    </div>
    
    <SevenShipContainer/>

    <div className="relative">
    <img
    src="/images/cut2.png"
    alt="Bottom Torn Paper"
    className="block w-full h-auto object-cover border-none outline-none"
    />
    </div>
      <NewsSection/>
    </div>
  );
};

export default HomePage;
